var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscopeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.25C5.41421 1.25 5.75 1.58579 5.75 2V6C5.75 6.41421 5.41421 6.75 5 6.75C4.58579 6.75 4.25 6.41421 4.25 6V4.75H4C3.30964 4.75 2.75 5.30964 2.75 6V9C2.75 11.8995 5.1005 14.25 8 14.25C10.8995 14.25 13.25 11.8995 13.25 9V6C13.25 5.30964 12.6904 4.75 12 4.75H11.75V6C11.75 6.41421 11.4142 6.75 11 6.75C10.5858 6.75 10.25 6.41421 10.25 6V2C10.25 1.58579 10.5858 1.25 11 1.25C11.4142 1.25 11.75 1.58579 11.75 2V3.25H12C13.5188 3.25 14.75 4.48122 14.75 6V9C14.75 12.6442 11.8621 15.6139 8.25 15.7455V17C8.25 19.3473 10.1524 21.25 12.4995 21.25H14.0007C16.3478 21.25 18.25 19.3473 18.25 17V14.9055C16.9561 14.5725 16 13.3979 16 12C16 10.3431 17.3431 9 19 9C20.6569 9 22 10.3431 22 12C22 13.3979 21.0439 14.5725 19.75 14.9055V17C19.75 20.1755 17.1765 22.75 14.0007 22.75H12.4995C9.32376 22.75 6.75 20.1755 6.75 17V15.6345C3.61929 15.0483 1.25 12.3008 1.25 9V6C1.25 4.48122 2.48122 3.25 4 3.25H4.25V2C4.25 1.58579 4.58579 1.25 5 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscopeAlt);
export default __webpack_public_path__ + "static/media/stethoscope-alt.5d40a603030eef07fd7a055d48dca550.svg";
export { ForwardRef as ReactComponent };